import {
  setTaskCalendarOverride as _setTaskCalendarOverride,
  SetTaskCalendarOverrideOptions,
} from '@griply/services';
import {
  deleteField,
  doc,
  getFirestore,
  serverTimestamp,
  updateDoc,
} from 'firebase/firestore';
import {
  FirestoreWriteOp,
  logFirestoreWriteError,
} from 'shared/services/error-tracking';

export type SetTaskCalendarOverrideInput = Pick<
  SetTaskCalendarOverrideOptions,
  'connectionId' | 'taskId' | 'override'
>;

export const setTaskCalendarOverride = (
  input: SetTaskCalendarOverrideInput,
): void =>
  _setTaskCalendarOverride({
    ...input,
    doc,
    updateDoc,
    db: getFirestore(),
    serverTimestamp,
    deleteField,
    onWriteError: (error) =>
      logFirestoreWriteError({
        op: FirestoreWriteOp.SetTaskCalendarOverride,
        error,
        docPath: `external-connections/${input.connectionId}`,
      }),
  });
